export default __webpack_public_path__ + "media/images/logo_full-4f531370f8ab23cd34058f3a7c2464ca.svg";